import { Dropdown } from "@/components/common/inputs";
import { useState } from "react";
import { Button } from "@/components/common/buttons";
import { TranslatedText } from "@/components/common/text";

export const ProfileDropdown = ({ initialValue, items, saveValue, loading }) => {
    const [value, setValue] = useState(initialValue);

    return (
        <div className="flex flex-col md:flex-row items-start md:items-center h-[54px]">
            <Dropdown
                className="w-full mb-1 md:mb-0 md:mr-1 md:max-w-[250px] rounded-l h-[54px] px-5 py-4"
                items={items}
                value={value}
                setValue={(newValue) => {
                    setValue(items.find((item) => item.id === newValue));
                }}
            />
            <div className="flex h-[54px] w-[117px] ml-4">
                <Button onClick={() => saveValue(value)} disabled={loading}>
                    <TranslatedText text="Save" />
                </Button>
            </div>
        </div>
    );
};
